import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum DateDurationType {
  sevenDays,
  oneMonth,
  oneYear,
  custom,
}
export interface DateFilterStore {
  startDate: Date;
  endDate: Date;
  dateDurationType: DateDurationType;
}

const initialState: DateFilterStore = {
  startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
  endDate: new Date(),
  dateDurationType: DateDurationType.sevenDays,
};

const slice = createSlice({
  name: "date-filter",
  initialState,
  reducers: {
    initFilter: () => {
      return initialState;
    },
    setCustomStartDate: (
      state: DateFilterStore,
      action: PayloadAction<Date>,
    ) => {
      state.startDate = action.payload;
      state.dateDurationType = DateDurationType.custom;
    },
    setCustomEndDate: (state: DateFilterStore, action: PayloadAction<Date>) => {
      state.endDate = action.payload;
      state.dateDurationType = DateDurationType.custom;
    },
    setDateDurationType: (
      state: DateFilterStore,
      action: PayloadAction<DateDurationType>,
    ) => {
      const todayDate = new Date();
      state.dateDurationType = action.payload;
      state.endDate = new Date();
      if (action.payload === DateDurationType.sevenDays) {
        state.startDate = new Date(new Date().setDate(todayDate.getDate() - 7));
      } else if (action.payload === DateDurationType.oneMonth) {
        state.startDate = new Date(
          new Date().setDate(todayDate.getDate() - 30),
        );
      } else if (action.payload === DateDurationType.oneYear) {
        state.startDate = new Date(
          todayDate.setDate(new Date().getDate() - 30 * 12),
        );
      }
    },
  },
});

export const {
  setCustomStartDate,
  setCustomEndDate,
  setDateDurationType,
  initFilter,
} = slice.actions;
export const reducer = slice.reducer;
